import React from "react";
import styles from "./RadioInput.module.sass";

const radioInput = props => {
  return (
    <div className={styles.radioContainer}>
      <div
        tabIndex={0}
        onClick={props.onSelected}
        onKeyPress={(event) => {
          event.key === 'Enter' && props.onSelected(event)
        }}
        className={
          styles.RadioInput + (props.selected ? " " + styles.selected : "")
        }
      >
        <div className={styles.checkMark} />
      </div>
      {props.icon && <i className={"icon icon-" + props.icon} />}
      <span>{props.children}</span>
    </div>
  );
};

export default radioInput;
